import { render, staticRenderFns } from "./ItemPreview.vue?vue&type=template&id=0fb560ba&scoped=true"
import script from "./ItemPreview.vue?vue&type=script&lang=js"
export * from "./ItemPreview.vue?vue&type=script&lang=js"
import style0 from "./ItemPreview.vue?vue&type=style&index=0&id=0fb560ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb560ba",
  null
  
)

export default component.exports